import "./App.scss";
import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import router from "./Routes";
import { ContextProvider } from "./Context/AuthContext";
const App = () => {
  const userRole = window.localStorage.getItem("userRole");
  const [userRoles, setUserRoles] = useState(null);
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  useEffect(() => {
    const storedUserRole = window.localStorage.getItem("userRole");
    if (storedUserRole) {
      setUserRoles(storedUserRole);
    }
  }, []);
  useEffect(() => {
    const handleResizeObserverError = (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications." ||
        e.message ===
          "NotFoundError: Node.removeChild: The node to be removed is not a child of this node"
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div",
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay",
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.style.display = "none";
        }
      }
    };

    window.addEventListener("error", handleResizeObserverError);

    return () => {
      window.removeEventListener("error", handleResizeObserverError);
    };
  }, []);

  const filterRoutesByRole  = (routes, role) => {
    return routes
      .map((route) => {
        if (route.children) {
          route.children = filterRoutesByRole(route.children, role);
        }
        if (route.access && !route.access.includes(role)) {
          return null; // Filter out the route if user's role is not in the access array
        }
        return route;
      })
      .filter((route) => route !== null);
  };

  // Filter routes based on user's role
  useEffect(() => {
    if (userRole) {
      setFilteredRoutes(filterRoutesByRole(router.routes, userRole));
    }


  }, [userRole])

  const queryClient = new QueryClient();
  return (
    <ContextProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ContextProvider>
  );
};

export default App;
